<template>
    <div class="project-container">
        <div class="top-title">
            <h2>宁夏 5G 设施智慧农业试点建设项目</h2>
        </div>

        <!-- 证书与描述区 -->
        <el-row :gutter="16" class="main-content">
            <!-- 左侧：数字农业智能驾驶舱 -->
            <el-col :span="8">
                <img :src="dashboardImg" alt="数字农业智能驾驶舱" class="main-img">
            </el-col>

            <!-- 右侧：平台描述 -->
            <el-col :span="14">
                <div class="desc-card">
                    <p>
                        我公司于2023年开始实施的宁夏5G设施智慧农业试点建设项目，以5G技术为核心，集成环境感知、大数据分析及物联网设备，建成覆盖整个园区的智慧农业体系。通过我公司部署的智能环境调控系统、水肥一体化系统、云智翼轨道打药系统、5G数据可视化大屏等，实现温室环境精准调控、农事操作全流程自动化，降低人工成本30%，资源利用率提升25%。
                    </p>
                    <p>
                        该项目由我公司全程设计实施，落地后获宁夏政府高度评价，成为西北地区5G+农业融合标杆案例，吸引多地农业部门考察学习，助力当地农业向数字化、集约化转型升级。
                    </p>
                </div>
            </el-col>
        </el-row>

        <!-- 底部图片展示区 -->
        <div class="image-grid">
            <el-row :gutter="15">
                <el-col :span="8">
                    <img src="@/assets/images/MainTypicalcase/zhtwo.png" alt="" class="project-img">
                    <p class="img-p">
                        配备我公司高精度
                        空气温湿度传感器
                    </p>
                </el-col>
                <el-col :span="8">
                    <img src="@/assets/images/MainTypicalcase/zhthree.png" alt="" class="project-img">
                    <p class="img-p">
                        配备我公司云智翼轨道式打药系统
                    </p>
                </el-col>
                <el-col :span="8">
                    <img src="@/assets/images/MainTypicalcase/zhfour.png" alt="" class="project-img">
                    <p class="img-p">
                        配备我公司定制
                        5G集成型智能控制柜
                    </p>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NingxiaProjectPage',
    data() {
        return {
            dashboardImg: require('@/assets/images/MainTypicalcase/zhone.png')

        }
    }
}
</script>